import type { IFrame } from '@src/slide/domain/ui-model/element-modeles/property/frame/frame.interface';
import type {
    IRefElement,
    MarginRefGroup,
    RefSourceType,
    SymmetryRefGroup,
} from '@src/slide/application/service/snap-line-service/interface/ref.interface';
import type { EdgeType, Orient } from '@src/slide/application/service/snap-line-service/interface/orient.interface';

/*
 * 网格线类型
 */
export enum LineType {
    EDGE = 'edge',              // 边缘线
    BASE_LINE = 'baseLine',     // 基线
    MARGIN = 'margin',          // 间距
    RECT = 'rect',              // 宽高
}

export interface ISnapGridLine {
    position: number;       // 网格线的位置，相对于x/y轴的距离
    orient: Orient;     // 网格线的方向
    maxAdsorbGap: number;   // 最大吸附距离阈值
    type: LineType;         // 网格线类型
    source: RefSourceType;
    refElements: IRefElement[];
    fromEdge?: EdgeType;    // snapLine的来源边类型
}

export enum MarginSnapLineType {
    EXTEND,
    BETWEEN,
}

export interface IMarginSnapGridLine extends ISnapGridLine {
    adsorbEdge?: EdgeType;  // 吸附的目标边类型
    margin: string;
    marginType: MarginSnapLineType;
}

export interface IActiveSnapGridLine extends ISnapGridLine {
    activeAdsorbGap: number;    // 实际触发的吸附距离
    frame: IFrame;
    frameOnSlide?: IFrame;
}

export interface IActiveMarginSnapGridLine extends IActiveSnapGridLine, IMarginSnapGridLine {
    equalMarginRefGroup: MarginRefGroup | SymmetryRefGroup;
}

export interface IAddMarginSnapLineOption {
    frontRef: IRefElement;
    behindRef: IRefElement;
    position: number;
    margin: number;
    orient: Orient;
    // 目标吸附的边的方向（因为间距是相对的边之间的间距，只能有一边能够吸附）
    adsorbEdge: EdgeType;
    source?: RefSourceType;
}
